import { render } from "./RequestAttendanceView.vue?vue&type=template&id=34dec7ed"
import script from "./RequestAttendanceView.vue?vue&type=script&lang=js"
export * from "./RequestAttendanceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__